import React, { RefObject, FC } from 'react'

interface DisplayFieldsProps {
  mobile: boolean
  firstField: RefObject<HTMLInputElement>
  secondField: RefObject<HTMLInputElement>
}

const DisplayFields: FC<DisplayFieldsProps> = ({
  mobile,
  firstField,
  secondField,
}) => {
  if (mobile) {
    return (
      <div>
        <div>{firstField}</div>
        <div>{secondField}</div>
      </div>
    )
  }
  return (
    <div className="flex flex-auto">
      <div className="flex-auto mr5">{firstField}</div>
      <div className="flex-auto document-field">
        <div data-cy="document-field">{secondField}</div>
      </div>
    </div>
  )
}

export default DisplayFields
